import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from '@contexts/useTheme';
import type { ThemePreference } from '@contexts/ThemeContext';
import PageHeader, {
  PAGE_HEADER_VARIANT_SMALL,
} from '@components/2-molecules/PageHeader';
import SettingDropDown from '@components/2-molecules/SettingDropDown';
import { Frame } from '../Settings.styled';
import { Wrapper } from './PreferencesSettings.styled';

const THEME_OPTIONS: { value: ThemePreference; label: string; leadingIconName?: string }[] = [
  { value: 'SYSTEM', label: 'System', leadingIconName: 'contrast_0' },
  { value: 'light', label: 'Light', leadingIconName: 'light_mode_0' },
  { value: 'dark', label: 'Dark', leadingIconName: 'dark_mode_0' },
];

const PreferencesSettings: React.FC = () => {
  const intl = useIntl();
  const { themePreference, setThemePreference } = useTheme();

  const currentThemeOption = THEME_OPTIONS.find((o) => o.value === themePreference) ?? THEME_OPTIONS[0];

  const themeDropdownItems = THEME_OPTIONS.map((option) => ({
    label: intl.formatMessage({
      id: `settings.account.theme.${option.value}`,
      defaultMessage: option.label,
    }),
    leadingIconName: option.leadingIconName,
    selected: option.value === themePreference,
    formFieldValue: {
      label: intl.formatMessage({
        id: `settings.account.theme.${option.value}`,
        defaultMessage: option.label,
      }),
      value: option.value,
    },
    onClick: () => setThemePreference(option.value),
  }));

  return (
    <Wrapper data-testid="preferences-settings">
      <PageHeader
        dataTestId="settings-page__appearance-header"
        variant={PAGE_HEADER_VARIANT_SMALL}
        title={intl.formatMessage({ id: 'settings.account.appearance', defaultMessage: 'Appearance' })}
      />
      <Frame>
        <SettingDropDown
          dataTestId="settings-page__appearance__theme"
          label={intl.formatMessage({ id: 'settings.account.theme', defaultMessage: 'Theme' })}
          dropDownField={{
            dropDownMenuItems: themeDropdownItems,
            value: intl.formatMessage({
              id: `settings.account.theme.${currentThemeOption.value}`,
              defaultMessage: currentThemeOption.label,
            }),
            leadingIconName: currentThemeOption.leadingIconName,
            fullWidthDropDownMenu: false,
          }}
        />
      </Frame>
    </Wrapper>
  );
};

export default PreferencesSettings;
